import PropTypes from 'prop-types';
import React from 'react';

import { NoticeMark } from 'common-src/components/base';

import { getNoticeDetail, getNoticeLabel, getNoticeTone } from './mocaPrompt';
import useMocaPrompt from './useMocaPrompt';

const MocaDayMark = ({ appt }) => {
  const moca = useMocaPrompt(appt, 'Provider HUD');
  if (!appt?.lowMocaPrompt) return null;

  return (
    <NoticeMark
      tone={getNoticeTone(moca.state)}
      label={getNoticeLabel(moca.state)}
      detail={getNoticeDetail(appt.latestMoca, moca.state)}
    />
  );
};

MocaDayMark.propTypes = { appt: PropTypes.object };

export default MocaDayMark;
